import React from "react";
import { Row, Col, Table } from "reactstrap";

const AdultShirtTable = () => {
  return (
    <Row>
      <Col style={{ marginTop: "10px" }}>
        Kokotaulukko:
        <Table striped>
          <thead>
            <tr>
              <th>Mitta</th>
              <th>S</th>
              <th>M</th>
              <th>L</th>
              <th>XL</th>
              <th>XXL</th>
              <th>3XL</th>
              <th>4XL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Rinnan ymp.</td>
              <td>88</td>
              <td>96</td>
              <td>104</td>
              <td>112</td>
              <td>116</td>
              <td>122</td>
              <td>126</td>
            </tr>
            <tr>
              <td>Pituus</td>
              <td>62</td>
              <td>64</td>
              <td>66</td>
              <td>68</td>
              <td>70</td>
              <td>72</td>
              <td>74</td>
            </tr>
            <tr>
              <td>Hihan pit.</td>
              <td>48</td>
              <td>50</td>
              <td>52</td>
              <td>52</td>
              <td>54</td>
              <td>56</td>
              <td>56</td>
            </tr>
            <tr>
              <td>Käsivarsi</td>
              <td>33</td>
              <td>35</td>
              <td>38</td>
              <td>42</td>
              <td>44</td>
              <td>46</td>
              <td>46</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default AdultShirtTable;
